export default {
  /**
   * Set Personal Leave entitlement List.
   *
   * @param state
   * @param data
   */
  setPersonalAwayEntitlementList(state, data) {
    state.items = data;
  },

  /**
   * Set Personal Leave entitlement Pagination.
   *
   * @param state
   * @param pagination
   */
  setPersonalAwayEntitlementListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set Personal Leave entitlement Page.
   *
   * @param state
   * @param currentPage
   */
  setPersonalAwayEntitlementListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   * Set Personal Leave entitlement Page busy state.
   *
   * @param state
   * @param isBusy
   */
  setPersonalAwayEntitlementListBusy(state, isBusy) {
    state.isBusy = isBusy;
  },

  /**
   * Set personal leave entitlement form.
   *
   * @param state
   * @param form
   */
  setPersonalAwayEntitlementForm(state, form) {
    console.log("Form : ", form);

    state.form = form;
  },
};
